module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLight.f7f6f70f.woff2";